import { render, staticRenderFns } from "./FailedToFetchModal.vue?vue&type=template&id=53048deb&scoped=true&"
import script from "./FailedToFetchModal.vue?vue&type=script&lang=js&"
export * from "./FailedToFetchModal.vue?vue&type=script&lang=js&"
import style0 from "./FailedToFetchModal.vue?vue&type=style&index=0&id=53048deb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53048deb",
  null
  
)

export default component.exports